import styled, {css} from "styled-components"

import Button from "@irati/ui/src/Button"

export const SectionHeader = styled.div`
  display: inline-flex;
  align-items: center;
  width: 100%;
  justify-content: space-between;
  ${({theme}) => css`
    padding-top: ${theme.spacing.one};
    margin: 0 0 ${theme.spacing.one};
    ${theme.mediaQueries.minWidthMedia.tablet`
      margin: 0 0 ${theme.spacing.four};
    `}
  `}
`

export const DesktopOnlyButton = styled(Button)`
  ${({theme}) => css`
    ${theme.mediaQueries.maxWidthMedia.tablet`
      display: none;
    `}
  `}
`
